// extracted by mini-css-extract-plugin
export default {"permissions-table":"PermissionsTable_permissions-table__4lxkS"};